import React, { useEffect, useState } from 'react';
import { AddIcon } from '../../../../components/icons';
import { Button } from './styles';
import theme from '../../../../theme';

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    expand?: boolean;
}

const ButtonExpand: React.FC<Props> = ({ expand = true, ...rest }) => {
    const [hover, setHover] = useState<boolean>(expand);

    useEffect(() => {
        if (hover)
            setTimeout(() => setHover(false), 5000);
    }, [hover])

    return (
        <Button $hover={hover} {...rest}>
            <AddIcon iconColor={theme.primaryColor} />
            <span>Destinatário</span>
        </Button>
    );
};

export { ButtonExpand };
